import { KTCard } from '../../../_metronic/helpers'
import { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import Question from './Question'
import { AES, enc } from 'crypto-js'
import { question, APIQuestion } from './SMSTpv.types'
import { useSearchParams } from 'react-router-dom'
import { useLazyQuery, useMutation } from '@apollo/client'
import { GET_ALL_QUESTIONS_BY_PINCODE, SAVE_SMS_ANSWER } from '../../../utils/GraphQLAPI'
import { generateSaveAnswerPayload } from './SMSTpvUtils'
import { alert } from '../../../utils/helper'
import 'react-loading-skeleton/dist/skeleton.css'
import moment from 'moment'
import SkeletonLoader from '../../sharedComponent/Skeleton'
const SMSTPV = () => {
  const [errMsg, setErrMsg] = useState('')
  const [isVerified, SetIsVerified] = useState(false)
  const [queryParams] = useSearchParams()
  const [cryptedData, setdecryptedData] = useState<any>(null)
  const [questionsLoading, setQuestionsLoading] = useState<boolean>(true)
  const [questions, setQuestions] = useState<Array<question>>([])
  const [customerName, setCustomerName] = useState<string>('')
  //queries
  const [getAllQuestions] = useLazyQuery(GET_ALL_QUESTIONS_BY_PINCODE, {
    onCompleted: (data) => {
      setQuestions(
        data.getAllQuetionsByPincode.map(
          (
            { questionId, questionDescription, continueCall, questionType, enrollmentPosition }: APIQuestion,
            index: number
          ) => ({
            id: questionId + enrollmentPosition,
            question: questionDescription,
            questionType: questionType,
            position: index,
            isYes: false,
            isNo: false,
            dtmfAnswer: '',
            answered: false,
            continueCall: continueCall,
            error: false,
            enrollmentPosition: enrollmentPosition
          })
        )
      )
      SetIsVerified(true)
      setQuestionsLoading(false)
    },
    onError: (err) => {
      setQuestionsLoading(false)
      setErrMsg(err.message)
    },
  })
  const [saveAnswer] = useMutation(SAVE_SMS_ANSWER, {
    onCompleted: () => {
      SetIsVerified(false)
      setErrMsg('')
    },
    onError: (err) => setErrMsg(err.message),
  })
  //handlerfn

  const handleSmsSubmit = () => {
    const errorPayload = questions
      .filter(
        ({ answered, isYes, isNo, dtmfAnswer, questionType }: question) =>
          !answered || (questionType !== 'SPEECH_ONLY' && !isYes && !isNo && !Boolean(dtmfAnswer))
      )
      .map((question: question) => question.id)
    if (errorPayload.length) {
      alert('Please answer all the questions', 'warning')
      setQuestions((prev) =>
        prev.map((question: question) => {
          if (errorPayload.includes(question.id)) {
            return {
              ...question,
              error: true,
            }
          }
          return question
        })
      )
    } else {
      saveAnswer({
        variables: {
          pincode: cryptedData?.pincode,
          tpvId: cryptedData?.tpvId,
          clientId: cryptedData?.clientId,
          answerInput: generateSaveAnswerPayload(questions),
        },
      })
    }
  }

  useEffect(() => {
    setQuestionsLoading(true)
    const urlParams: any = queryParams.get('pincode')
    const decryptedData = JSON.parse(
      AES.decrypt(urlParams.replaceAll(' ', '+'), 'gDdoxYdfT5XCJw0y').toString(enc.Utf8)
    )
    setCustomerName(decryptedData?.customerName)
    setdecryptedData(decryptedData)
    const startTime = moment(decryptedData?.linkCreationTime) // Current time
    const endTime = moment() // Current time + 1 hour    // Calculate the time difference in milliseconds
    const timeDifferenceMilliseconds = endTime.diff(startTime)
    if (moment.duration(timeDifferenceMilliseconds).asMinutes() && decryptedData?.pincode) {
      getAllQuestions({
        variables: {
          pincode: decryptedData?.pincode,
          tpvId: decryptedData?.tpvId,
          clientId: decryptedData?.clientId,
        },
      })
    } else {
      setQuestionsLoading(false)
      setErrMsg('Sorry! The link has expired, please contact our agent.')
    }
  }, [])
  if (questionsLoading) {
    return <SkeletonLoader />
  }
  if (errMsg) {
    return (
      <Container>
        <div className='text-center alert alert-danger mt-5'>
          <h4 className='fs7'> {errMsg}</h4>
        </div>
      </Container>
    )
  }
  if (isVerified) {
    return (
      <Container>
        <KTCard className='mt-5 p-5'>
          <h3 className='text-center'>{`Hi ${customerName}, please answer the following questions`}</h3>
          <div className='card card-custom'>
            <div className='card-header card-body flex-column justify-content-center  align-items-center pb-0 border-0'>
              {questions.map((question: question, index) => (
                <Question
                  key={question.id}
                  questionData={question}
                  setQuestions={setQuestions}
                  questionDisabled={index !== 0 && !Boolean(questions[index - 1]?.answered)}
                  questions={questions}
                  saveAnswer={saveAnswer}
                  pincode={cryptedData.pincode}
                />
              ))}
            </div>
            <button
              className='btn btn-primary mw-150px align-self-center'
              disabled={questions.filter(({ answered }: question) => !answered).length > 0}
              onClick={() => handleSmsSubmit()}
            >
              Submit
            </button>
          </div>
        </KTCard>
      </Container>
    )
  } else {
    return (
      <Container>
        <div className='text-center alert alert-success mt-5'>
          <h4 className='fs7'> TPV completed successfully, Goodbye!</h4>
        </div>
      </Container>
    )
  }
}
export default SMSTPV
